import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "C'est quoi la différence avec une agence ?",
      answer: "Une agence te livre souvent un site ou des visuels, mais rarement un système interconnecté. Moi, je construis une machine complète : positionnement + tunnel + emails + automatisations. Tout fonctionne ensemble, et je te forme pour que tu sois autonome.",
    },
    {
      question: "Je n'ai pas encore de site / logo / rien du tout. C'est trop tôt ?",
      answer: "C'est le meilleur moment. Construire un site sans système de vente derrière, c'est comme ouvrir une boutique sans porte d'entrée. On part sur des bases saines dès le jour 1.",
    },
    {
      question: "Je ne suis pas technique, comment je vais gérer après ?",
      answer: "Le système est complexe à construire (c'est mon job), mais ultra simple à utiliser (c'est ton job). Je te livre des tutoriels vidéos personnalisés pour que tu sois totalement autonome.",
    },
    {
      question: "Combien de temps ça prend ?",
      answer: "L'offre Système Glow se déroule sur 6 semaines. Le diagnostic est un one-shot de 2h + livrable sous 5 jours.",
    },
    {
      question: "Pourquoi investir maintenant ?",
      answer: "Chaque jour passé sans système est un jour où tu échanges ton temps contre de l'argent de manière inefficace. Plus tôt tu automatises, plus vite tu récupères ta vie.",
    },
  ];

  return (
    <section id="faq" className="section-lg bg-off-white">
      <div className="container mx-auto px-4 content-medium">
        <div className="reveal">
          <h2 className="reveal-child font-display text-4xl sm:text-5xl lg:text-6xl text-foreground mb-12 leading-[1.1]">
            Questions fréquentes
          </h2>
        </div>

        <div className="reveal space-y-0 border-t border-border">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={index} className="reveal-child border-b border-border">
                <button
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="w-full min-h-[48px] py-6 text-left flex items-center justify-between gap-4 group"
                >
                  <h3 className={`font-body text-base font-medium transition-colors duration-300 ${
                    isOpen ? 'text-primary' : 'text-foreground group-hover:text-primary'
                  }`}>
                    {faq.question}
                  </h3>
                  <ChevronDown
                    className={`w-5 h-5 text-muted-foreground flex-shrink-0 transition-all duration-300 group-hover:translate-y-0.5 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <div className={`accordion-grid ${isOpen ? 'open' : ''}`}>
                  <div>
                    <div className="pb-6 pr-8">
                      <p className="text-muted-foreground text-sm leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
